var _defs, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _circle2, _circle3, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 401.846,
    height: 152.21,
    viewBox: "0 0 401.846 152.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.465,
    y1: 1.722,
    x2: 0.546,
    y2: -1.09,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8d0018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0009"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.001,
    y1: -0.153,
    x2: 0.939,
    y2: 1.074,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#8d0018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ff0009"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.403,
    y1: 1.363,
    x2: 0.531,
    y2: 0.218,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.457,
    y1: 1.523,
    x2: 0.531,
    y2: -0.232,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.012,
    y1: -0.399,
    x2: 0.939,
    y2: 1.307,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.088,
    y1: -0.285,
    x2: 0.665,
    y2: 0.814,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.373,
    cy: 0.155,
    r: 1.14,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#ff000a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9e0018"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.524,
    y1: 1.103,
    x2: 0.478,
    y2: -0.037,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4353e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#aa353e",
    stopOpacity: 0.169
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#91353e",
    stopOpacity: 0.588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a363e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.46,
    y1: 1.016,
    x2: 0.53,
    y2: 0.104,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.456,
    y1: 2.123,
    x2: 0.512,
    y2: 0.037,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -0.001,
    y1: 0.499,
    x2: 1,
    y2: 0.499,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d10011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#dc000e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb000b"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.373,
    cy: 0.156,
    r: 1.139,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.654,
    cy: 0.166,
    r: 1.14,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.096,
    y1: 0.503,
    x2: 18.516,
    y2: 0.358,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -0.837,
    y1: 0.512,
    x2: 14.646,
    y2: 0.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -2.178,
    y1: 0.52,
    x2: 14.557,
    y2: 0.376,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -2.364,
    y1: 0.534,
    x2: 10.683,
    y2: 0.39,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -3.484,
    y1: 0.543,
    x2: 9.743,
    y2: 0.401,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -25.831,
    y1: 0.552,
    x2: 47.74,
    y2: 0.407,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -4.802,
    y1: 0.559,
    x2: 7.924,
    y2: 0.418,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -6.902,
    y1: 0.573,
    x2: 7.406,
    y2: 0.428,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -9.059,
    y1: 0.584,
    x2: 7.13,
    y2: 0.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -8.195,
    y1: 0.598,
    x2: 4.852,
    y2: 0.454,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -10.341,
    y1: 0.605,
    x2: 4.133,
    y2: 0.461,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -58.577,
    y1: 0.616,
    x2: 14.994,
    y2: 0.472,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -12.368,
    y1: 0.624,
    x2: 2.594,
    y2: 0.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -11.97,
    y1: 0.634,
    x2: 1.25,
    y2: 0.492,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_97",
    "data-name": "Rect\\xE1ngulo 97",
    width: 401.846,
    height: 12.222,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "logo",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_194",
    "data-name": "Grupo 194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_191",
    "data-name": "Grupo 191",
    transform: "translate(126.997)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_379",
    "data-name": "Trazado 379",
    d: "M93.38,53.533h12.991c5.717,0,11.6-4.636,13.122-10.354l1.18-4.44a233.507,233.507,0,0,1-24.082,2.769L93.38,53.517Z",
    transform: "translate(-67.397 24.726)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_380",
    "data-name": "Trazado 380",
    d: "M142.157,47.329,154.837,0H141.846c-5.717,0-11.6,4.636-13.122,10.354L116.42,56.29c4.98-1.36,9.911-2.916,14.777-4.636q5.554-1.941,10.96-4.309Z",
    transform: "translate(-52.692)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_381",
    "data-name": "Trazado 381",
    d: "M132.28,64.454h12.991c5.717,0,11.6-4.636,13.122-10.354l8.7-32.47a156.106,156.106,0,0,1-27.441,15.3L132.28,64.454Z",
    transform: "translate(-42.57 13.805)",
    fill: "url(#linear-gradient-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_382",
    "data-name": "Trazado 382",
    d: "M112.83,57.005h12.991c5.717,0,11.6-4.636,13.122-10.354L142.515,33.3a183.717,183.717,0,0,1-25.278,7.225L112.83,57.005Z",
    transform: "translate(-54.983 21.254)",
    fill: "url(#linear-gradient-4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_383",
    "data-name": "Trazado 383",
    d: "M127.7,19.07H114.7c-5.717,0-11.6,4.636-13.122,10.354L95.93,50.508a219.548,219.548,0,0,0,24.426-4.079l7.323-27.342Z",
    transform: "translate(-65.77 12.171)",
    fill: "url(#linear-gradient-5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_384",
    "data-name": "Trazado 384",
    d: "M166.53,19.648,170.118,6.28H157.126c-5.717,0-11.6,4.636-13.122,10.354L138.09,38.685a149.762,149.762,0,0,0,27.539-18.234c.213-.2.541-.475.9-.8Z",
    transform: "translate(-38.861 4.008)",
    fill: "url(#linear-gradient-6)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_4",
    "data-name": "Elipse 4",
    cx: 7.29,
    cy: 7.29,
    r: 7.29,
    transform: "translate(133.271 9.846)",
    opacity: 0.2,
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_385",
    "data-name": "Trazado 385",
    d: "M130.268,12.369c1.54-5.717,7.4-10.354,13.122-10.354h10.862L154.792,0H141.817c-5.717,0-11.6,4.636-13.122,10.354l-12.2,45.527c.77-.213,1.54-.442,2.31-.672l11.484-42.824Z",
    transform: "translate(-52.647)",
    fill: "url(#linear-gradient-7)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_386",
    "data-name": "Trazado 386",
    d: "M103.152,31.445c1.524-5.717,7.4-10.354,13.122-10.354h10.862l.541-2.031H114.685c-5.717,0-11.6,4.636-13.122,10.354l-5.6,20.9c.737-.082,1.474-.164,2.2-.262l5-18.627Z",
    transform: "translate(-65.751 12.165)",
    fill: "url(#linear-gradient-8)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_387",
    "data-name": "Trazado 387",
    d: "M145.5,18.655c1.54-5.717,7.4-10.354,13.122-10.354h10.862l.541-2.031H157.053c-5.717,0-11.6,4.636-13.122,10.354l-5.7,21.264c.835-.442,1.671-.9,2.49-1.36L145.5,18.655Z",
    transform: "translate(-38.772 4.002)",
    fill: "url(#linear-gradient-9)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_388",
    "data-name": "Trazado 388",
    d: "M77.536,58.512a201.25,201.25,0,0,0,37.811-1.605c6.258-.836,12.483-1.917,18.627-3.276q9.24-2.015,18.25-4.915a163.357,163.357,0,0,0,17.611-6.766l2.146-.95,2.113-1.032c1.409-.7,2.834-1.36,4.227-2.081,2.752-1.507,5.537-2.949,8.208-4.6A136.815,136.815,0,0,0,215.772,10.02l2.769,2.736-3.522,3.276-1.769,1.638-1.851,1.54-3.686,3.064-3.833,2.883c-.639.475-1.261.967-1.917,1.442l-1.982,1.36c-1.327.885-2.621,1.818-3.965,2.687-2.72,1.671-5.406,3.408-8.224,4.9-2.752,1.605-5.636,2.982-8.47,4.423-1.442.688-2.9,1.327-4.341,1.982l-2.179.983-2.212.9c-1.474.59-2.932,1.229-4.423,1.769l-4.472,1.638c-1.491.524-3.014,1-4.522,1.507s-3.031.967-4.538,1.409q-9.117,2.728-18.463,4.554c-6.209,1.229-12.483,2.2-18.774,2.883-6.291.7-12.614,1.13-18.922,1.311-3.162.1-6.324.131-9.485.082s-6.324-.147-9.469-.41Z",
    transform: "translate(-77.52 6.395)",
    fill: "url(#linear-gradient-10)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_5",
    "data-name": "Elipse 5",
    cx: 5.947,
    cy: 5.947,
    r: 5.947,
    transform: "translate(134.615 11.189)",
    opacity: 0.5,
    fill: "url(#radial-gradient-2)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_6",
    "data-name": "Elipse 6",
    cx: 4.44,
    cy: 4.44,
    r: 4.44,
    transform: "translate(134.286 17.138) rotate(-45)",
    fill: "url(#radial-gradient-3)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_193",
    "data-name": "Grupo 193",
    transform: "translate(0 94.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_425",
    "data-name": "Trazado 425",
    d: "M0,57.92H22.116v5.16H5.16v9.01H21.117v4.964H5.16v9.453H22.116v5.16H0V57.936Z",
    transform: "translate(0 -57.527)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_426",
    "data-name": "Trazado 426",
    d: "M14.74,81.347h5.98c.819,3.571,3.473,5.734,7.847,5.734s6.455-2.654,6.455-5.062c0-2.556-1.589-4.243-6.16-4.718-9.879-1.065-13.2-5.16-13.2-9.682,0-5.439,5.062-9.879,12.041-9.879,7.618,0,12.336,4.046,12.631,10.7H34.645c-.246-3.522-3.326-5.488-7-5.488-3.948,0-5.98,2.359-5.98,4.489,0,2.654,2.7,4.243,6.848,4.718C38.2,73.271,41.05,77.219,41.05,82.084c0,6.16-5.259,10.026-12.483,10.026-6.7,0-13.3-3.522-13.827-10.747Z",
    transform: "translate(9.408 -57.642)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_427",
    "data-name": "Trazado 427",
    d: "M33.666,57.939l14.449-.049c5.93,0,9.879,4.489,9.879,10.3A9.714,9.714,0,0,1,47.821,78.319H38.86v13.4H33.65V57.939ZM46.772,73.748c3.326,0,5.98-1.884,5.98-5.586s-2.654-5.685-5.98-5.685h-7.9V73.748h7.9Z",
    transform: "translate(21.477 -57.546)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_428",
    "data-name": "Trazado 428",
    d: "M46.366,91.6,59.276,57.92h5.39L77.575,91.652H71.546l-3.178-8.29H55.508l-3.129,8.29L46.35,91.6ZM66.943,78.546,61.979,64.522,56.966,78.546Z",
    transform: "translate(29.583 -57.527)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_429",
    "data-name": "Trazado 429",
    d: "M66.816,75.059C66.866,65.131,73.468,57.71,82.9,57.71c8.388,0,13.679,5.39,14.7,12.238H91.521a8.711,8.711,0,0,0-8.863-6.979c-6.127,0-9.928,5.488-9.928,12.139s3.8,11.713,9.731,11.713a9.048,9.048,0,0,0,9.06-7.126H97.6c-1.114,6.651-6.356,12.336-15.039,12.336S66.751,84.856,66.8,75.075Z",
    transform: "translate(42.635 -57.661)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_430",
    "data-name": "Trazado 430",
    d: "M88.61,57.92h5.537V91.652H88.61V57.92Z",
    transform: "translate(56.555 -57.527)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_431",
    "data-name": "Trazado 431",
    d: "M95.14,74.931c0-10.124,7.126-17.251,16.006-17.251s16.006,7.176,16.006,17.349S120.025,92.28,111.146,92.28,95.14,85.1,95.14,74.931Zm26.458.246c0-7.126-4.341-12.434-10.452-12.434S100.792,68,100.792,75.078s4.292,12.041,10.3,12.041,10.5-5.062,10.5-11.943Z",
    transform: "translate(60.723 -57.68)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_432",
    "data-name": "Trazado 432",
    d: "M132.973,62.884H121.309l-.049-4.964h28.424l.049,4.964-11.615-.049-.049,28.817h-5.16l.049-28.768Z",
    transform: "translate(77.394 -57.527)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_433",
    "data-name": "Trazado 433",
    d: "M140.476,57.939l14.548-.049c5.93,0,9.879,4.1,9.879,9.305,0,4.44-2.556,7.47-5.111,8.339,2.982.967,4.194,3.621,4.538,7.765.393,4.669.147,6.258,1.294,8.388h-5.98c-.721-1.737-.672-3.571-.917-7.176-.344-4.718-1.016-7.077-6.946-7.077h-6.029V91.753H140.46V57.972Zm13.2,14.892c3.326,0,5.98-1.442,5.98-5.16s-2.654-5.21-5.98-5.21h-7.913V72.814h7.913Z",
    transform: "translate(89.648 -57.546)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_434",
    "data-name": "Trazado 434",
    d: "M157.516,91.6,170.426,57.92h5.39l12.909,33.732H182.7l-3.178-8.29h-12.86l-3.129,8.29L157.5,91.6Zm20.576-13.057-4.964-14.023-5.013,14.023Z",
    transform: "translate(100.524 -57.527)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_435",
    "data-name": "Trazado 435",
    d: "M178.98,57.959l12.09-.1c9.109-.1,16.055,6.9,16.055,16.727s-6.75,17.054-15.563,17.1l-12.582.1V57.959Zm11.91,28.62c6.078-.1,10.894-4.767,10.894-11.812S197.066,63,191.087,63.1l-7.077.1V86.677l6.9-.1Z",
    transform: "translate(114.234 -57.566)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_436",
    "data-name": "Trazado 436",
    d: "M199.31,57.92h5.537V91.652H199.31V57.92Z",
    transform: "translate(127.209 -57.527)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_437",
    "data-name": "Trazado 437",
    d: "M211.932,65.865V91.652H206.87V57.92h6.5l15.662,26.605V57.92H234.1V91.7l-7-.049L211.916,65.866Z",
    transform: "translate(132.034 -57.527)",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_438",
    "data-name": "Trazado 438",
    d: "M226.513,75.059c.049-9.928,6.651-17.349,16.088-17.349,8.388,0,13.679,5.39,14.7,12.238h-6.078a8.71,8.71,0,0,0-8.863-6.979c-6.127,0-9.928,5.488-9.928,12.139s3.85,11.763,9.78,11.713c4-.049,8.24-2.064,9.535-7.372h-9.633V74.437h15.17V91.786h-4.62l-.393-4.964a11.745,11.745,0,0,1-10.174,5.21c-8.961,0-15.662-7.176-15.612-16.956Z",
    transform: "translate(144.55 -57.661)",
    fill: "url(#linear-gradient-24)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_255",
    "data-name": "Grupo 255",
    transform: "translate(0 139.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_254",
    "data-name": "Grupo 254",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_501",
    "data-name": "Trazado 501",
    d: "M10.355,6.059A6.69,6.69,0,0,1,9.929,8.5a5.388,5.388,0,0,1-1.2,1.885A5.365,5.365,0,0,1,6.866,11.6a6.5,6.5,0,0,1-2.4.43H0V.081H4.461a6.5,6.5,0,0,1,2.4.43A5.327,5.327,0,0,1,8.729,1.727a5.44,5.44,0,0,1,1.2,1.89,6.693,6.693,0,0,1,.426,2.443m-1.659,0a6.006,6.006,0,0,0-.3-1.967,4.168,4.168,0,0,0-.849-1.468A3.644,3.644,0,0,0,6.21,1.706a4.672,4.672,0,0,0-1.75-.316H1.616v9.33H4.461A4.64,4.64,0,0,0,6.21,10.4,3.672,3.672,0,0,0,7.545,9.49a4.13,4.13,0,0,0,.849-1.463,6.02,6.02,0,0,0,.3-1.967",
    transform: "translate(0 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_502",
    "data-name": "Trazado 502",
    d: "M18.871,6.112a6.864,6.864,0,0,1-.426,2.462,5.671,5.671,0,0,1-1.2,1.931,5.4,5.4,0,0,1-1.865,1.254,6.307,6.307,0,0,1-2.4.446,6.278,6.278,0,0,1-2.4-.446A5.374,5.374,0,0,1,8.717,10.5a5.628,5.628,0,0,1-1.2-1.931,6.936,6.936,0,0,1-.423-2.462,6.939,6.939,0,0,1,.423-2.464,5.658,5.658,0,0,1,1.2-1.934A5.371,5.371,0,0,1,10.575.451,6.187,6.187,0,0,1,12.977,0a6.215,6.215,0,0,1,2.4.451,5.4,5.4,0,0,1,1.865,1.263,5.7,5.7,0,0,1,1.2,1.934,6.867,6.867,0,0,1,.426,2.464m-1.659,0a6.052,6.052,0,0,0-.3-1.977,4.181,4.181,0,0,0-.849-1.48,3.691,3.691,0,0,0-1.335-.93,4.865,4.865,0,0,0-3.493,0,3.725,3.725,0,0,0-1.337.93,4.144,4.144,0,0,0-.856,1.48,6.1,6.1,0,0,0-.3,1.977,6.049,6.049,0,0,0,.3,1.97A4.157,4.157,0,0,0,9.9,9.558a3.673,3.673,0,0,0,1.337.925,4.912,4.912,0,0,0,3.493,0,3.639,3.639,0,0,0,1.335-.925,4.2,4.2,0,0,0,.849-1.476,6,6,0,0,0,.3-1.97",
    transform: "translate(4.582 0)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_503",
    "data-name": "Trazado 503",
    d: "M25.168.081V12.028h-.81a.719.719,0,0,1-.321-.066.815.815,0,0,1-.253-.227l-6.912-9c.012.14.02.275.026.408s.007.26.007.377v8.512H15.488V.081h.835a.966.966,0,0,1,.183.013.438.438,0,0,1,.133.041.563.563,0,0,1,.117.082,1.2,1.2,0,0,1,.125.138l6.912,9c-.012-.145-.021-.285-.03-.421s-.012-.265-.012-.387V.081Z",
    transform: "translate(10.006 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_504",
    "data-name": "Trazado 504",
    d: "M33.416,6.059A6.69,6.69,0,0,1,32.99,8.5a5.263,5.263,0,0,1-3.063,3.1,6.5,6.5,0,0,1-2.4.43H23.061V.081h4.461a6.5,6.5,0,0,1,2.4.43A5.327,5.327,0,0,1,31.79,1.727a5.44,5.44,0,0,1,1.2,1.89,6.693,6.693,0,0,1,.426,2.443m-1.659,0a6.006,6.006,0,0,0-.3-1.967,4.167,4.167,0,0,0-.849-1.468,3.644,3.644,0,0,0-1.335-.918,4.672,4.672,0,0,0-1.75-.316H24.677v9.33h2.844a4.64,4.64,0,0,0,1.75-.316,3.672,3.672,0,0,0,1.335-.914,4.13,4.13,0,0,0,.849-1.463,6.02,6.02,0,0,0,.3-1.967",
    transform: "translate(14.898 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_505",
    "data-name": "Trazado 505",
    d: "M37.972,10.711l-.008,1.317H30.6V.081h7.363V1.4H32.219V5.366h4.652V6.632H32.219v4.079Z",
    transform: "translate(19.769 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_506",
    "data-name": "Trazado 506",
    d: "M45.5,10.67v1.358H38.721V.081h1.608V10.67Z",
    transform: "translate(25.015 0.052)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_507",
    "data-name": "Trazado 507",
    d: "M54.051,12.027H52.8a.532.532,0,0,1-.349-.107.669.669,0,0,1-.2-.277L51.133,8.76H45.773l-1.118,2.884a.593.593,0,0,1-.191.267.531.531,0,0,1-.351.117H42.863L47.64.082h1.635ZM50.683,7.593,48.807,2.732c-.056-.145-.114-.313-.174-.505s-.119-.4-.176-.612A8.867,8.867,0,0,1,48.1,2.74L46.223,7.593Z",
    transform: "translate(27.691 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_508",
    "data-name": "Trazado 508",
    d: "M56.951,2a.593.593,0,0,1-.163.186.354.354,0,0,1-.214.063.588.588,0,0,1-.332-.142,5.46,5.46,0,0,0-.479-.311,3.861,3.861,0,0,0-.693-.313,2.949,2.949,0,0,0-.978-.142,2.86,2.86,0,0,0-.955.145,2.006,2.006,0,0,0-.691.4,1.575,1.575,0,0,0-.421.588,1.847,1.847,0,0,0-.143.729,1.344,1.344,0,0,0,.245.828,2.13,2.13,0,0,0,.652.565,5.042,5.042,0,0,0,.915.4l1.052.356q.538.183,1.05.412a3.693,3.693,0,0,1,.917.581,2.63,2.63,0,0,1,.652.858,2.872,2.872,0,0,1,.245,1.251,4.025,4.025,0,0,1-.267,1.47,3.391,3.391,0,0,1-.779,1.2,3.639,3.639,0,0,1-1.261.8,4.594,4.594,0,0,1-1.7.293,5.149,5.149,0,0,1-2.117-.421,4.939,4.939,0,0,1-1.628-1.137l.469-.767a.6.6,0,0,1,.161-.155.386.386,0,0,1,.212-.063.462.462,0,0,1,.245.089c.092.058.2.132.314.221s.249.186.4.291a3.208,3.208,0,0,0,.514.291,3.488,3.488,0,0,0,.653.222,3.592,3.592,0,0,0,.825.087,3.09,3.09,0,0,0,1.025-.16,2.137,2.137,0,0,0,.764-.446,1.922,1.922,0,0,0,.479-.686,2.322,2.322,0,0,0,.168-.892,1.493,1.493,0,0,0-.247-.889,2.055,2.055,0,0,0-.645-.579,4.525,4.525,0,0,0-.918-.4l-1.05-.334a10.91,10.91,0,0,1-1.05-.4,3.358,3.358,0,0,1-.917-.583,2.7,2.7,0,0,1-.647-.9,3.212,3.212,0,0,1-.245-1.332,3.177,3.177,0,0,1,.245-1.225,3.134,3.134,0,0,1,.718-1.052A3.513,3.513,0,0,1,52.5.275,4.235,4.235,0,0,1,54.074,0,5.041,5.041,0,0,1,55.9.318a4.291,4.291,0,0,1,1.447.915Z",
    transform: "translate(32.213 0)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_509",
    "data-name": "Trazado 509",
    d: "M70.65.081V12.028H69.233V3.25c0-.117,0-.244.013-.377s.016-.268.03-.408l-4.1,7.47a.617.617,0,0,1-.583.377h-.235a.625.625,0,0,1-.584-.377l-4.184-7.5a7.434,7.434,0,0,1,.053.818v8.778H58.219V.081h1.193a1.064,1.064,0,0,1,.333.041.484.484,0,0,1,.227.234L64.1,7.709c.066.133.13.273.194.418s.123.29.179.441c.053-.151.114-.3.174-.446a4.516,4.516,0,0,1,.2-.421L68.9.356a.442.442,0,0,1,.219-.234,1.15,1.15,0,0,1,.339-.041Z",
    transform: "translate(37.611 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_510",
    "data-name": "Trazado 510",
    d: "M74.834,10.711l-.008,1.317H67.463V.081h7.363V1.4H69.081V5.366h4.652V6.632H69.081v4.079Z",
    transform: "translate(43.583 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_511",
    "data-name": "Trazado 511",
    d: "M82.831.081V12.028h-.81a.719.719,0,0,1-.321-.066.815.815,0,0,1-.253-.227l-6.912-9c.012.14.02.275.026.408s.007.26.007.377v8.512H73.151V.081h.835a.966.966,0,0,1,.183.013A.437.437,0,0,1,74.3.135a.563.563,0,0,1,.117.082,1.2,1.2,0,0,1,.125.138l6.912,9c-.012-.145-.021-.285-.03-.421s-.012-.265-.012-.387V.081Z",
    transform: "translate(47.257 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_512",
    "data-name": "Trazado 512",
    d: "M89.3,1.439h-3.87V12.028H83.825V1.439H79.949V.081H89.3Z",
    transform: "translate(51.649 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_513",
    "data-name": "Trazado 513",
    d: "M93.913,10.711l-.008,1.317H86.543V.081h7.363V1.4H88.161V5.366h4.652V6.632H88.161v4.079Z",
    transform: "translate(55.909 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_514",
    "data-name": "Trazado 514",
    d: "M98.725,2a.593.593,0,0,1-.163.186.354.354,0,0,1-.214.063.588.588,0,0,1-.332-.142,5.461,5.461,0,0,0-.479-.311,3.862,3.862,0,0,0-.693-.313,2.949,2.949,0,0,0-.978-.142,2.86,2.86,0,0,0-.955.145,2.006,2.006,0,0,0-.691.4,1.575,1.575,0,0,0-.421.588,1.847,1.847,0,0,0-.143.729,1.344,1.344,0,0,0,.245.828,2.13,2.13,0,0,0,.652.565,5.042,5.042,0,0,0,.915.4l1.052.356q.538.183,1.05.412a3.693,3.693,0,0,1,.917.581,2.63,2.63,0,0,1,.652.858,2.872,2.872,0,0,1,.245,1.251,4.025,4.025,0,0,1-.267,1.47,3.391,3.391,0,0,1-.779,1.2,3.639,3.639,0,0,1-1.261.8,4.594,4.594,0,0,1-1.7.293,5.149,5.149,0,0,1-2.117-.421,4.939,4.939,0,0,1-1.628-1.137l.469-.767a.6.6,0,0,1,.161-.155.386.386,0,0,1,.212-.063.462.462,0,0,1,.245.089c.092.058.2.132.314.221s.249.186.4.291a3.209,3.209,0,0,0,.514.291,3.489,3.489,0,0,0,.653.222,3.591,3.591,0,0,0,.825.087,3.09,3.09,0,0,0,1.025-.16,2.137,2.137,0,0,0,.764-.446A1.922,1.922,0,0,0,97.7,9.58a2.322,2.322,0,0,0,.168-.892A1.494,1.494,0,0,0,97.62,7.8a2.055,2.055,0,0,0-.645-.579,4.524,4.524,0,0,0-.918-.4l-1.05-.334a10.911,10.911,0,0,1-1.05-.4,3.358,3.358,0,0,1-.917-.583,2.7,2.7,0,0,1-.647-.9,3.212,3.212,0,0,1-.245-1.332,3.177,3.177,0,0,1,.245-1.225,3.134,3.134,0,0,1,.718-1.052A3.513,3.513,0,0,1,94.269.275,4.235,4.235,0,0,1,95.848,0,5.041,5.041,0,0,1,97.67.318a4.291,4.291,0,0,1,1.447.915Z",
    transform: "translate(59.2 0)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_515",
    "data-name": "Trazado 515",
    d: "M101.612,1.4V5.575h4.91V6.892h-4.91v5.136H100V.081h7.361V1.4Z",
    transform: "translate(64.6 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_95",
    "data-name": "Rect\\xE1ngulo 95",
    width: 1.616,
    height: 11.947,
    transform: "translate(173.758 0.133)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_516",
    "data-name": "Trazado 516",
    d: "M117.915.081V12.028h-.81a.719.719,0,0,1-.321-.066.815.815,0,0,1-.253-.227l-6.912-9c.012.14.02.275.026.408s.007.26.007.377v8.512h-1.417V.081h.835a.966.966,0,0,1,.183.013.437.437,0,0,1,.133.041.563.563,0,0,1,.117.082,1.2,1.2,0,0,1,.125.138l6.912,9c-.012-.145-.021-.285-.03-.421s-.012-.265-.012-.387V.081Z",
    transform: "translate(69.923 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_517",
    "data-name": "Trazado 517",
    d: "M126.1,12.027h-1.251a.532.532,0,0,1-.349-.107.669.669,0,0,1-.2-.277L123.181,8.76h-5.359L116.7,11.644a.593.593,0,0,1-.191.267.531.531,0,0,1-.351.117h-1.251L119.688.082h1.634Zm-3.368-4.434-1.876-4.861c-.056-.145-.114-.313-.174-.505s-.119-.4-.176-.612a8.865,8.865,0,0,1-.357,1.126l-1.876,4.852Z",
    transform: "translate(74.235 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_518",
    "data-name": "Trazado 518",
    d: "M132.183.081V12.028h-.81a.719.719,0,0,1-.321-.066.815.815,0,0,1-.253-.227l-6.912-9c.012.14.02.275.026.408s.007.26.007.377v8.512H122.5V.081h.835a.967.967,0,0,1,.183.013.438.438,0,0,1,.133.041.564.564,0,0,1,.117.082,1.206,1.206,0,0,1,.125.138l6.912,9c-.012-.145-.021-.285-.03-.421s-.012-.265-.012-.387V.081Z",
    transform: "translate(79.14 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_519",
    "data-name": "Trazado 519",
    d: "M138.751,9.613a.308.308,0,0,1,.234.107l.64.693a5.1,5.1,0,0,1-1.779,1.325,6.1,6.1,0,0,1-2.53.476,5.93,5.93,0,0,1-2.334-.444,5.145,5.145,0,0,1-1.793-1.251,5.632,5.632,0,0,1-1.151-1.931,7.186,7.186,0,0,1-.408-2.476,6.963,6.963,0,0,1,.425-2.477,5.722,5.722,0,0,1,1.2-1.934A5.366,5.366,0,0,1,133.1.446,6.139,6.139,0,0,1,135.473,0a5.815,5.815,0,0,1,2.252.408,5.671,5.671,0,0,1,1.717,1.109l-.533.741a.431.431,0,0,1-.128.138.376.376,0,0,1-.212.054.668.668,0,0,1-.369-.161,5.225,5.225,0,0,0-.566-.364,4.188,4.188,0,0,0-2.168-.525,4.335,4.335,0,0,0-1.692.321,3.674,3.674,0,0,0-1.322.93,4.249,4.249,0,0,0-.862,1.483,5.919,5.919,0,0,0-.308,1.977A5.759,5.759,0,0,0,131.6,8.1a4.41,4.41,0,0,0,.876,1.48,3.726,3.726,0,0,0,1.309.922,4.182,4.182,0,0,0,1.631.316,6.585,6.585,0,0,0,.963-.063,3.925,3.925,0,0,0,.792-.2,3.316,3.316,0,0,0,.675-.337,4.928,4.928,0,0,0,.621-.487.431.431,0,0,1,.285-.125",
    transform: "translate(83.744 0)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_96",
    "data-name": "Rect\\xE1ngulo 96",
    width: 1.616,
    height: 11.947,
    transform: "translate(224.979 0.133)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_520",
    "data-name": "Trazado 520",
    d: "M146.724,10.711l-.008,1.317h-7.363V.081h7.363V1.4h-5.745V5.366h4.652V6.632h-4.652v4.079Z",
    transform: "translate(90.026 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_521",
    "data-name": "Trazado 521",
    d: "M153.873,12.028h-1.437a.7.7,0,0,1-.649-.342l-3.1-4.268a.9.9,0,0,0-.3-.286,1.1,1.1,0,0,0-.5-.087h-1.226v4.984h-1.61V.081h3.378a7.353,7.353,0,0,1,1.957.229,3.786,3.786,0,0,1,1.365.663,2.681,2.681,0,0,1,.8,1.047,3.51,3.51,0,0,1,.258,1.371,3.436,3.436,0,0,1-.2,1.183,3.132,3.132,0,0,1-.578.988,3.528,3.528,0,0,1-.927.747,4.646,4.646,0,0,1-1.238.467,1.591,1.591,0,0,1,.533.507Zm-5.521-6.161A4.046,4.046,0,0,0,149.59,5.7a2.543,2.543,0,0,0,.9-.482,2,2,0,0,0,.546-.747,2.444,2.444,0,0,0,.183-.96,1.909,1.909,0,0,0-.7-1.608,3.407,3.407,0,0,0-2.1-.542h-1.768v4.51Z",
    transform: "translate(93.701 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_522",
    "data-name": "Trazado 522",
    d: "M161.517,12.027h-1.251a.532.532,0,0,1-.349-.107.669.669,0,0,1-.2-.277L158.6,8.76h-5.359l-1.118,2.884a.593.593,0,0,1-.191.267.531.531,0,0,1-.351.117h-1.251L155.106.082h1.635Zm-3.368-4.434-1.876-4.861c-.056-.145-.114-.313-.174-.505s-.119-.4-.176-.612a8.867,8.867,0,0,1-.357,1.126l-1.876,4.852Z",
    transform: "translate(97.116 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_523",
    "data-name": "Trazado 523",
    d: "M164.416,2a.593.593,0,0,1-.163.186.354.354,0,0,1-.214.063.588.588,0,0,1-.332-.142,5.467,5.467,0,0,0-.479-.311,3.862,3.862,0,0,0-.693-.313,2.949,2.949,0,0,0-.978-.142,2.861,2.861,0,0,0-.955.145,2.006,2.006,0,0,0-.691.4,1.575,1.575,0,0,0-.421.588,1.847,1.847,0,0,0-.143.729,1.344,1.344,0,0,0,.245.828,2.13,2.13,0,0,0,.652.565,5.043,5.043,0,0,0,.915.4l1.052.356q.538.183,1.05.412a3.694,3.694,0,0,1,.917.581,2.629,2.629,0,0,1,.652.858,2.872,2.872,0,0,1,.245,1.251,4.025,4.025,0,0,1-.267,1.47,3.39,3.39,0,0,1-.779,1.2,3.639,3.639,0,0,1-1.261.8,4.594,4.594,0,0,1-1.7.293,5.149,5.149,0,0,1-2.117-.421,4.939,4.939,0,0,1-1.628-1.137l.469-.767a.6.6,0,0,1,.161-.155.386.386,0,0,1,.212-.063.462.462,0,0,1,.245.089c.092.058.2.132.314.221s.249.186.4.291a3.21,3.21,0,0,0,.514.291,3.489,3.489,0,0,0,.653.222,3.592,3.592,0,0,0,.825.087,3.09,3.09,0,0,0,1.025-.16,2.137,2.137,0,0,0,.764-.446,1.923,1.923,0,0,0,.479-.686,2.323,2.323,0,0,0,.168-.892,1.493,1.493,0,0,0-.247-.889,2.055,2.055,0,0,0-.645-.579,4.525,4.525,0,0,0-.918-.4L160.7,6.49a10.91,10.91,0,0,1-1.05-.4,3.359,3.359,0,0,1-.917-.583,2.7,2.7,0,0,1-.647-.9,3.212,3.212,0,0,1-.245-1.332,3.177,3.177,0,0,1,.245-1.225,3.134,3.134,0,0,1,.718-1.052A3.513,3.513,0,0,1,159.96.275,4.235,4.235,0,0,1,161.539,0a5.041,5.041,0,0,1,1.822.318,4.291,4.291,0,0,1,1.447.915Z",
    transform: "translate(101.638 0)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_524",
    "data-name": "Trazado 524",
    d: "M172.18,2a.593.593,0,0,1-.163.186.354.354,0,0,1-.214.063.588.588,0,0,1-.333-.142,5.461,5.461,0,0,0-.479-.311,3.86,3.86,0,0,0-.693-.313,2.949,2.949,0,0,0-.978-.142,2.861,2.861,0,0,0-.955.145,2.006,2.006,0,0,0-.691.4,1.576,1.576,0,0,0-.421.588,1.847,1.847,0,0,0-.143.729,1.344,1.344,0,0,0,.245.828,2.13,2.13,0,0,0,.652.565,5.042,5.042,0,0,0,.915.4l1.052.356q.538.183,1.05.412a3.693,3.693,0,0,1,.917.581,2.63,2.63,0,0,1,.652.858,2.872,2.872,0,0,1,.245,1.251,4.026,4.026,0,0,1-.267,1.47,3.391,3.391,0,0,1-.779,1.2,3.639,3.639,0,0,1-1.261.8,4.594,4.594,0,0,1-1.7.293,5.149,5.149,0,0,1-2.117-.421,4.94,4.94,0,0,1-1.628-1.137l.469-.767a.6.6,0,0,1,.161-.155.386.386,0,0,1,.212-.063.462.462,0,0,1,.245.089c.092.058.2.132.314.221s.249.186.4.291a3.208,3.208,0,0,0,.514.291,3.489,3.489,0,0,0,.653.222,3.592,3.592,0,0,0,.825.087,3.09,3.09,0,0,0,1.025-.16,2.137,2.137,0,0,0,.764-.446,1.922,1.922,0,0,0,.479-.686,2.322,2.322,0,0,0,.168-.892,1.494,1.494,0,0,0-.247-.889,2.056,2.056,0,0,0-.645-.579,4.525,4.525,0,0,0-.919-.4l-1.05-.334a10.905,10.905,0,0,1-1.05-.4,3.359,3.359,0,0,1-.917-.583,2.7,2.7,0,0,1-.647-.9,3.212,3.212,0,0,1-.245-1.332,3.177,3.177,0,0,1,.245-1.225,3.134,3.134,0,0,1,.718-1.052,3.514,3.514,0,0,1,1.159-.732A4.235,4.235,0,0,1,169.3,0a5.041,5.041,0,0,1,1.822.318,4.291,4.291,0,0,1,1.447.915Z",
    transform: "translate(106.654 0)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_525",
    "data-name": "Trazado 525",
    d: "M178.389,10.711l-.008,1.317h-7.363V.081h7.363V1.4h-5.745V5.366h4.652V6.632h-4.652v4.079Z",
    transform: "translate(110.482 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_526",
    "data-name": "Trazado 526",
    d: "M186.508,10.711l-.008,1.317h-7.363V.081H186.5V1.4h-5.745V5.366h4.652V6.632h-4.652v4.079Z",
    transform: "translate(115.727 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_527",
    "data-name": "Trazado 527",
    d: "M194.506.081V12.028h-.81a.719.719,0,0,1-.321-.066.815.815,0,0,1-.253-.227l-6.912-9c.011.14.02.275.026.408s.007.26.007.377v8.512h-1.417V.081h.835a.966.966,0,0,1,.183.013.437.437,0,0,1,.133.041.563.563,0,0,1,.117.082,1.2,1.2,0,0,1,.125.138l6.912,9c-.012-.145-.021-.285-.03-.421s-.012-.265-.012-.387V.081Z",
    transform: "translate(119.402 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_528",
    "data-name": "Trazado 528",
    d: "M201.073,9.613a.308.308,0,0,1,.234.107l.64.693a5.1,5.1,0,0,1-1.779,1.325,6.1,6.1,0,0,1-2.53.476,5.929,5.929,0,0,1-2.334-.444,5.145,5.145,0,0,1-1.793-1.251,5.633,5.633,0,0,1-1.151-1.931,7.187,7.187,0,0,1-.408-2.476,6.962,6.962,0,0,1,.425-2.477A5.722,5.722,0,0,1,193.572,1.7,5.366,5.366,0,0,1,195.419.446,6.139,6.139,0,0,1,197.8,0a5.815,5.815,0,0,1,2.252.408,5.67,5.67,0,0,1,1.717,1.109l-.533.741a.432.432,0,0,1-.128.138.376.376,0,0,1-.212.054.668.668,0,0,1-.369-.161,5.221,5.221,0,0,0-.566-.364,4.188,4.188,0,0,0-2.168-.525,4.335,4.335,0,0,0-1.692.321,3.674,3.674,0,0,0-1.322.93,4.25,4.25,0,0,0-.863,1.483,5.92,5.92,0,0,0-.308,1.977,5.759,5.759,0,0,0,.319,1.992,4.41,4.41,0,0,0,.876,1.48,3.726,3.726,0,0,0,1.309.922,4.182,4.182,0,0,0,1.631.316,6.585,6.585,0,0,0,.963-.063,3.923,3.923,0,0,0,.792-.2,3.315,3.315,0,0,0,.675-.337,4.918,4.918,0,0,0,.621-.487.431.431,0,0,1,.285-.125",
    transform: "translate(124.006 0)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_529",
    "data-name": "Trazado 529",
    d: "M203.671,10.744A3.38,3.38,0,0,0,205,10.5a2.79,2.79,0,0,0,.986-.7,3.081,3.081,0,0,0,.617-1.075,4.262,4.262,0,0,0,.214-1.376V.081h1.608V7.343a5.5,5.5,0,0,1-.328,1.918,4.463,4.463,0,0,1-.943,1.529,4.338,4.338,0,0,1-1.5,1.014,5.57,5.57,0,0,1-3.969,0,4.3,4.3,0,0,1-2.446-2.543,5.425,5.425,0,0,1-.331-1.918V.081h1.61V7.335a4.27,4.27,0,0,0,.212,1.376,3.065,3.065,0,0,0,.617,1.075,2.788,2.788,0,0,0,.991.7,3.321,3.321,0,0,0,1.33.253",
    transform: "translate(128.501 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_530",
    "data-name": "Trazado 530",
    d: "M213.661,10.711l-.008,1.317H206.29V.081h7.363V1.4h-5.745V5.366h4.652V6.632h-4.652v4.079Z",
    transform: "translate(133.268 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_531",
    "data-name": "Trazado 531",
    d: "M221.658.081V12.028h-.81a.719.719,0,0,1-.321-.066.815.815,0,0,1-.253-.227l-6.912-9c.012.14.02.275.026.408s.007.26.007.377v8.512h-1.417V.081h.835A.966.966,0,0,1,213,.094a.437.437,0,0,1,.133.041.563.563,0,0,1,.117.082,1.2,1.2,0,0,1,.125.138l6.912,9c-.012-.145-.021-.285-.03-.421s-.012-.265-.012-.387V.081Z",
    transform: "translate(136.943 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_532",
    "data-name": "Trazado 532",
    d: "M228.129,1.439h-3.87V12.028h-1.608V1.439h-3.876V.081h9.354Z",
    transform: "translate(141.334 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_533",
    "data-name": "Trazado 533",
    d: "M234.2,12.028h-1.437a.7.7,0,0,1-.649-.342l-3.1-4.268a.9.9,0,0,0-.3-.286,1.1,1.1,0,0,0-.5-.087H226.98v4.984h-1.61V.081h3.378A7.352,7.352,0,0,1,230.7.31a3.786,3.786,0,0,1,1.365.663,2.681,2.681,0,0,1,.8,1.047,3.51,3.51,0,0,1,.258,1.371,3.436,3.436,0,0,1-.2,1.183,3.131,3.131,0,0,1-.578.988,3.528,3.528,0,0,1-.927.747,4.646,4.646,0,0,1-1.238.467,1.591,1.591,0,0,1,.533.507ZM228.68,5.867a4.046,4.046,0,0,0,1.238-.171,2.543,2.543,0,0,0,.9-.482,2,2,0,0,0,.546-.747,2.445,2.445,0,0,0,.183-.96,1.909,1.909,0,0,0-.7-1.608,3.407,3.407,0,0,0-2.1-.542H226.98v4.51Z",
    transform: "translate(145.595 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_534",
    "data-name": "Trazado 534",
    d: "M241.845,12.027h-1.251a.532.532,0,0,1-.349-.107.669.669,0,0,1-.2-.277L238.927,8.76h-5.359l-1.118,2.884a.593.593,0,0,1-.191.267.531.531,0,0,1-.351.117h-1.251L235.434.082h1.634Zm-3.368-4.434L236.6,2.732c-.056-.145-.114-.313-.175-.505s-.119-.4-.176-.612a8.87,8.87,0,0,1-.357,1.126l-1.877,4.852Z",
    transform: "translate(149.01 0.053)",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_535",
    "data-name": "Trazado 535",
    d: "M247.93.081V12.028h-.81a.719.719,0,0,1-.321-.066.815.815,0,0,1-.254-.227l-6.912-9c.012.14.02.275.026.408s.007.26.007.377v8.512H238.25V.081h.835a.966.966,0,0,1,.183.013.437.437,0,0,1,.133.041.564.564,0,0,1,.117.082,1.2,1.2,0,0,1,.125.138l6.912,9c-.012-.145-.021-.285-.03-.421s-.011-.265-.011-.387V.081Z",
    transform: "translate(153.915 0.053)",
    fill: "#050505"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.164e0d469e7b531280bfae76fed2de35.svg";
export { ForwardRef as ReactComponent };